var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegionSelectorSingaporeFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 80,
    viewBox: "0 0 136 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_995_8615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 40H0.992676V2.10535C0.992676 0.942732 2.03503 0 3.32049 0H133.672C134.958 0 136 0.942732 136 2.10535L136 40Z",
    fill: "#D93025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.992676 40H136V77.8946C136 79.0573 134.958 80 133.672 80H3.3205C2.03503 80 0.992676 79.0573 0.992676 77.8946V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1221 20.03C18.1221 13.1073 23.1648 7.3686 29.7494 6.30711C30.1068 6.24939 30.1229 5.75406 29.7702 5.67202C28.14 5.2945 26.4087 5.18694 24.6108 5.43353C17.509 6.40798 12.0193 12.5991 11.9189 19.8185C11.8046 28.062 18.4017 34.7744 26.5462 34.7744C27.6549 34.7744 28.7314 34.6439 29.7673 34.4038C30.1199 34.3222 30.1021 33.8257 29.7451 33.768C23.1631 32.7072 18.1221 26.9797 18.1221 20.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8573 23.7342L29.2387 25.6029L27.2834 25.6182C27.0303 25.6203 26.9252 25.9456 27.129 26.0971L28.702 27.2673L28.112 29.1454C28.0358 29.3886 28.3106 29.5897 28.5164 29.4413L30.1073 28.2959L31.6982 29.4413C31.9042 29.5897 32.1788 29.3884 32.1026 29.1454L31.5126 27.2673L33.0855 26.0971C33.2894 25.9454 33.1842 25.6203 32.9312 25.6182L30.9759 25.6029L30.3573 23.7342C30.277 23.4923 29.9373 23.4923 29.8573 23.7342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5233 23.7342L38.9047 25.6029L36.9494 25.6182C36.6963 25.6203 36.5912 25.9456 36.795 26.0971L38.368 27.2673L37.778 29.1454C37.7018 29.3886 37.9766 29.5897 38.1824 29.4413L39.7733 28.2959L41.3642 29.4413C41.5702 29.5897 41.8448 29.3884 41.7686 29.1454L41.1786 27.2673L42.7515 26.0971C42.9554 25.9454 42.8503 25.6203 42.5972 25.6182L40.6419 25.6029L40.0233 23.7342C39.943 23.4923 39.6035 23.4923 39.5233 23.7342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7337 8.70841L34.1151 10.5772L32.1599 10.5924C31.9068 10.5946 31.8017 10.9199 32.0055 11.0713L33.5784 12.2416L32.9885 14.1196C32.9122 14.3629 33.1871 14.5639 33.3928 14.4156L34.9837 13.2702L36.5747 14.4156C36.7806 14.5639 37.0553 14.3627 36.979 14.1196L36.3891 12.2416L37.962 11.0713C38.1658 10.9196 38.0607 10.5946 37.8076 10.5924L35.8524 10.5772L35.2337 8.70841C35.1535 8.46658 34.8138 8.46658 34.7337 8.70841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0272 14.465L26.4086 16.3338L24.4533 16.349C24.2002 16.3512 24.0951 16.6765 24.299 16.8279L25.8719 17.9982L25.2819 19.8762C25.2057 20.1195 25.4805 20.3205 25.6863 20.1722L27.2772 19.0267L28.8681 20.1722C29.0741 20.3205 29.3487 20.1192 29.2725 19.8762L28.6825 17.9982L30.2554 16.8279C30.4593 16.6762 30.3542 16.3512 30.1011 16.349L28.1458 16.3338L27.5272 14.465C27.4469 14.2232 27.1075 14.2232 27.0272 14.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3753 14.465L41.7567 16.3338L39.8015 16.349C39.5484 16.3512 39.4433 16.6765 39.6471 16.8279L41.22 17.9982L40.6301 19.8762C40.5538 20.1195 40.8287 20.3205 41.0344 20.1722L42.6253 19.0267L44.2163 20.1722C44.4222 20.3205 44.6969 20.1192 44.6206 19.8762L44.0307 17.9982L45.6036 16.8279C45.8074 16.6762 45.7023 16.3512 45.4492 16.349L43.494 16.3338L42.8753 14.465C42.7951 14.2232 42.4554 14.2232 42.3753 14.465Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 135,
    height: 79,
    rx: 15.5,
    stroke: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_8615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 80,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionSelectorSingaporeFlag);
export default __webpack_public_path__ + "static/media/regionSelectorSingaporeFlag.af4567ea8365360ea814b76225bf31c7.svg";
export { ForwardRef as ReactComponent };